import {UrlApi} from "../../services/apirest"

export function validarHs(index, hs, validacionDiasHs, setValidacionDiasHs) {
  const newValue = parseInt(hs, 10);
  const newErrors = [...validacionDiasHs.errorHs];
  newErrors[index] = newValue > 24;
  setValidacionDiasHs({
    ...validacionDiasHs,
    errorHs: newErrors,
  });
}

export function validarDias(
  index,
  dias,
  validacionDiasHs,
  setValidacionDiasHs
) {
  const newValue = parseInt(dias, 10);
  const newErrors = [...validacionDiasHs.errorHs];
  newErrors[index] = newValue > 365;
  setValidacionDiasHs({
    ...validacionDiasHs,
    errorDias: newErrors,
  });
}

export function validarClientes(cliente, validado, setValidado) {
  let cuitOk = /^(?:\D*\d){8,}/.test(cliente.cuit);
  if (
    (!!cliente.razon_social || !!cliente.nombre && cliente.apellido) &&
    !!cliente.situacion_iva &&
    !!cliente.direccion_fiscal &&
    !!cliente.id_provincia &&
    !!cliente.id_localidad &&
    !!cliente.id_segmento &&
    !!cliente.id_sucursal &&
    !!cliente.id_comercial && 
    !!cliente.id_empresa &&
    !!cliente.id_condicionpago &&
    cuitOk && 
    !!cliente.mails 
  ) {
    setValidado({ ...validado, cliOK: true });
  } else {
    setValidado({ ...validado, cliOK: false });
  }
}

export function validarDirecciones(direccion, validado, setValidado, tipoFact) {
  if (tipoFact === 236) {
    if (!!direccion.latitud && !!direccion.longitud) {
      setValidado({ ...validado, dirOK: true });
    } else {
      setValidado({ ...validado, dirOK: false });
    }
  } else {
    if (
      !!direccion.direccion_entrega &&
      !!direccion.id_provincia &&
      !!direccion.id_localidad &&
      !!direccion.id_producto &&
      !!direccion.id_sucursal &&
      !!direccion.latitud &&
      !!direccion.longitud &&
      !!direccion.nombre_direccion &&
      !!direccion.id_tipomoneda
    ) {
      setValidado({ ...validado, dirOK: true });
    } else {
      setValidado({ ...validado, dirOK: false });
    }
  }
}

export function validarTanques(factibilidad, validado, setValidado) {
  if (
    !!factibilidad.canttk_05 ||
    !!factibilidad.canttk_1 ||
    !!factibilidad.canttk_2 ||
    !!factibilidad.canttk_4 ||
    !!factibilidad.canttk_7 ||
    !!factibilidad.canttk_otros
  ) {
    setValidado({ ...validado, tksOK: true });
  } else {
    setValidado({ ...validado, tksOK: false });
  }
}


export function validarCostos(factibilidad, validado, setValidado) {
  const condicionesOriginales = [
    (!factibilidad.motivo1 && !factibilidad.cantmotivo1) ||
      (!!factibilidad.motivo1 && !!factibilidad.cantmotivo1),
    (!factibilidad.motivocli1 && !factibilidad.cantmotivocli1) ||
      (!!factibilidad.motivocli1 && !!factibilidad.cantmotivocli1),
    // (!factibilidad.motivocli2 && !factibilidad.cantmotivocli2) ||
    //   (!!factibilidad.motivocli2 && !!factibilidad.cantmotivocli2),
    // (!factibilidad.motivocli3 && !factibilidad.cantmotivocli3) ||
    //   (!!factibilidad.motivocli3 && !!factibilidad.cantmotivocli3),
    !!factibilidad.cantmotivo1 
  ];
  const OK = condicionesOriginales.every((condicion) => condicion);
  setValidado((validado) => ({ ...validado, costosOK: OK }));
}

export function validarArtCompletos(listaArtefactos, validado, setValidado) {
  const todosConConsumoAnual = listaArtefactos.every(
    (artefacto) => artefacto.consumoanual !== "" && artefacto.consumoanual !== 0
  );
  setValidado({ ...validado, artOK: todosConConsumoAnual });
}

/* VALIDACIONES EN LA MODIFICACIÓN, YA QUE FUNCIONAN DE DISTINTA MANERA: */
export function validarCliMod(cliente, setCliOK) {
  let cuitOk = /^(?:\D*\d){8,}/.test(cliente.cuit);

  if (
    !!cliente.razon_social &&
    !!cliente.situacion_iva &&
    !!cliente.direccion_fiscal &&
    !!cliente.id_provincia &&
    !!cliente.id_localidad &&
    !!cliente.id_segmento &&
    !!cliente.id_comercial &&
    !!cliente.id_empresa &&
    cuitOk
  ) {
    setCliOK(true);
  } else {
    setCliOK(false);
  }
}

// VALIDACIONES EN LA MODIFICACIÓN, YA QUE FUNCIONAN DE DISTINTA MANERA:
export function validarDirMod(direccion, setDirOK) {
  if (
    !!direccion.direccion_entrega &&
    !!direccion.id_provincia &&
    !!direccion.id_localidad &&
    !!direccion.id_producto &&
    !!direccion.id_sucursal &&
    !!direccion.latitud &&
    !!direccion.longitud &&
    !!direccion.nombre_direccion &&
    !!direccion.id_tipomoneda
  ) {
    setDirOK(true);
  } else {
    setDirOK(false);
  }
}

export function validarCostosMod(factibilidad, setCostosOK) {
  const costosEmp1 = (!!factibilidad.motivo1 && (!!factibilidad.cantmotivo1 || factibilidad.cantmotivo1 === 0)) || (!factibilidad.motivo1 && !factibilidad.cantmotivo1);
  /*---------------------*/

  const costosCli1 = (!!factibilidad.motivocli1 && (!!factibilidad.cantmotivocli1 || factibilidad.cantmotivocli1 === 0)) || (!factibilidad.motivocli1 && !factibilidad.cantmotivocli1);
  // const costosCli2 = (!!factibilidad.motivocli2 && (!!factibilidad.cantmotivocli2 || factibilidad.cantmotivocli2 === 0)) || (!factibilidad.motivocli2 && !factibilidad.cantmotivocli2);
  // const costosCli3 = (!!factibilidad.motivocli3 && (!!factibilidad.cantmotivocli3 || factibilidad.cantmotivocli3 === 0)) || (!factibilidad.motivocli3 && !factibilidad.cantmotivocli3);

  const OK = 
    costosEmp1 === true &&
    costosCli1 === true 
    // &&
    // costosCli2 === true &&
    // costosCli3 === true;
  setCostosOK(OK);
}

export function validarTksMod(factibilidad, setTksOK) {
  if (
    !!factibilidad.canttk_05 ||
    !!factibilidad.canttk_1 ||
    !!factibilidad.canttk_2 ||
    !!factibilidad.canttk_4 ||
    !!factibilidad.canttk_7 ||
    !!factibilidad.canttk_otros
  ) {
    setTksOK(true);
  } else {
    setTksOK(false);
  }
}

